// extracted by mini-css-extract-plugin
export default {"container":"SendLoadToBBIButton_container__HlZMs","button":"SendLoadToBBIButton_button__u5hJw"};